var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav bg-gradient-primary sidebar sidebar-dark accordion",attrs:{"id":"accordionSidebar"}},[_c('a',{staticClass:"\n      navbar-brand\n      sidebar-brand\n      d-flex\n      align-items-center\n      justify-content-center\n    ",attrs:{"href":"/"}},[_c('div',{staticClass:"sidebar-brand-text mx-3"},[_vm._v("\n      "+_vm._s(_vm.appname)+"\n    ")])]),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'teacher'
    )?_c('div',{staticClass:"sidebar-heading"},[_vm._v("\n    Багш\n  ")]):_vm._e(),_c('router-link',{staticClass:"nav-item",attrs:{"to":"/dashboard"}},[_c('a',{staticClass:"nav-link",attrs:{"href":""}},[_c('i',{staticClass:"fas fa-fw fa-tachometer-alt"}),_c('span',[_vm._v("Dashboard")])])]),_c('router-link',{staticClass:"nav-item",attrs:{"to":"/mynews"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-book-open"}),_c('span',[_vm._v("Мэдээ")])])]),_c('router-link',{staticClass:"nav-item",attrs:{"to":"/asuulga"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-book-open"}),_c('span',[_vm._v("Санал асуулга")])])]),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      (_vm.userProfile.role == 'teacher' ||
        _vm.userProfile.role == 'sts' ||
        _vm.userProfile.role == 'admin')
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/hello"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-book-open"}),_c('span',[_vm._v("Миний хичээлүүд")])])]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      (_vm.userProfile.role == 'teacher' ||
        _vm.userProfile.role == 'sts' ||
        _vm.userProfile.role == 'admin')
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/groups"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-users"}),_c('span',[_vm._v("Миний группууд")])])]):_vm._e(),(_vm.schoolId != null)?[(
        _vm.currentUser != null &&
        _vm.userProfile != null &&
        (_vm.userProfile.role == 'manager' || _vm.userProfile.role == 'admin')
      )?_c('router-link',{staticClass:"nav-item",attrs:{"to":{
        name: 'SDepartments',
        params: { schoolId: _vm.schoolId },
      }}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-users"}),_c('span',[_vm._v("Ангиудын удирдлага")])])]):_vm._e(),(
        _vm.currentUser != null &&
        _vm.userProfile != null &&
        (_vm.userProfile.role == 'manager' || _vm.userProfile.role == 'admin')
      )?_c('router-link',{staticClass:"nav-item",attrs:{"to":{
        name: 'Dungiinhavtgai',
        params: { schoolId: _vm.schoolId },
      }}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-users"}),_c('span',[_vm._v("Дүнгийн нэгтгэл")])])]):_vm._e()]:_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      (_vm.userProfile.role == 'teacher' ||
        _vm.userProfile.role == 'sts' ||
        _vm.userProfile.role == 'manager' ||
        _vm.userProfile.role == 'admin')
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/onlinerooms"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-users"}),_c('span',[_vm._v("Ангийн Онлайн өрөөнүүд")])])]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      (_vm.userProfile.role == 'teacher' ||
        _vm.userProfile.role == 'sts' ||
        _vm.userProfile.role == 'manager' ||
        _vm.userProfile.role == 'admin')
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/songononlinerooms"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-users"}),_c('span',[_vm._v("Сонгон Онлайн өрөөнүүд")])])]):_vm._e(),_c('router-link',{staticClass:"nav-item",attrs:{"to":"/mycalendar"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-users"}),_c('span',[_vm._v("Xуваарь")])])]),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      (_vm.userProfile.role == 'teacher' ||
        _vm.userProfile.role == 'sts' ||
        _vm.userProfile.role == 'admin')
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/mydashboard"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-users"}),_c('span',[_vm._v("Charts")])])]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      (_vm.userProfile.role == 'teacher' ||
        _vm.userProfile.role == 'sts' ||
        _vm.userProfile.role == 'admin')
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/curriculum"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-users"}),_c('span',[_vm._v("Сургалтын xөтөлбөр")])])]):_vm._e(),_c('hr',{staticClass:"sidebar-divider"}),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'student'
    )?_c('div',{staticClass:"sidebar-heading"},[_vm._v("\n    Сурагч\n  ")]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'student'
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/lessons"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-book"}),_c('span',[_vm._v("Xичээлүүд")])])]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'student'
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/lessongridxdaalgavar"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-book"}),_c('span',[_vm._v("Даалгаварууд")])])]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'student'
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/alllessonstudentscores"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-book"}),_c('span',[_vm._v("Миний дүн")])])]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'student'
    )?_c('hr',{staticClass:"sidebar-divider d-none d-md-block"}):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'admin'
    )?_c('div',{staticClass:"sidebar-heading"},[_vm._v("\n    ADMIN\n  ")]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'admin'
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/subschools"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-school"}),_c('span',[_vm._v("Сургууль")])])]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'admin'
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/createschool"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-school"}),_c('span',[_vm._v("Сургууль үүсгэx")])])]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'admin'
    )?_c('router-link',{staticClass:"nav-item",attrs:{"to":"/cities"}},[_c('a',{staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-school"}),_c('span',[_vm._v("Хот/Дүүрэг")])])]):_vm._e(),(
      _vm.currentUser != null &&
      _vm.userProfile != null &&
      _vm.userProfile.role == 'admin'
    )?_c('hr',{staticClass:"sidebar-divider d-none d-md-block"}):_vm._e(),_c('div',{staticClass:"text-center d-none d-md-inline"},[_c('button',{staticClass:"rounded-circle border-0",attrs:{"id":"sidebarToggle"},on:{"click":_vm.toggleSideBar}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }